import type { VercelRunner } from '@cli-types/next-adapter/vercel.js'
import { spinner } from '@cli-utils/terminal.js'
import pc from 'picocolors'
import { pullVercelEnvValue } from '../env-pull.js'
import { readDbUrlFromDotenv } from '../neon/read-db-url-from-dotenv.js'

export async function pullNeonDatabaseUrl(
  runner: VercelRunner,
  cwd: string,
  env?: NodeJS.ProcessEnv
): Promise<string | undefined> {
  const neonSpinner = spinner()
  neonSpinner.start('Retrieving DATABASE_URL from Vercel')
  const databaseUrl = await pullVercelEnvValue(runner, cwd, readDbUrlFromDotenv, env)
  if (!databaseUrl) {
    neonSpinner.stop(`${pc.yellow('▲')} No DATABASE_URL came back from Vercel`)
    return undefined
  }

  neonSpinner.clear()
  return databaseUrl
}
